/**
 * Um `src` de botão é link externo?
 *
 * Vive fora do componente para poder ser testado — e porque a regra é de
 * segurança, não de layout: só `http(s)` abre janela. Sem esse filtro, um
 * plugin poderia declarar `src: "javascript:..."` e o clique executaria código
 * no contexto da sessão de quem está configurando.
 */
export default function linkExterno(src) {
  if (typeof src !== "string") return null;
  return /^https?:\/\//i.test(src.trim()) ? src.trim() : null;
}
